import { Icons } from '@/assets/icons/icons';
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRoot,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu/dropdown-menu';
import { XStack } from '@/components/ui/layout/layout';

interface CkDebugFilterDropdownOption {
  value: string;
  label: string;
  count?: number;
}

interface CkDebugFilterDropdownProps {
  title: string;
  selectedValue: string;
  allLabel: string;
  options: CkDebugFilterDropdownOption[];
  onSelect: (value: string) => void;
}

export function CkDebugFilterDropdown({
  title,
  selectedValue,
  allLabel,
  options,
  onSelect,
}: CkDebugFilterDropdownProps) {
  const buttonLabel = selectedValue || allLabel;

  return (
    <DropdownMenuRoot>
      <DropdownMenuTrigger size="sm">
        <span className="truncate max-w-[120px]">{buttonLabel}</span>
        <Icons.chevronDown className="h-3 w-3 shrink-0" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>{title}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => onSelect('')}
          className={!selectedValue ? 'bg-secondary-active' : ''}
        >
          {allLabel}
        </DropdownMenuItem>
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => onSelect(option.value)}
            className={
              selectedValue === option.value ? 'bg-secondary-active' : ''
            }
          >
            <XStack className="justify-between items-center w-full gap-2">
              <span className="truncate">{option.label}</span>
              {option.count !== undefined && (
                <span className="text-xs text-foreground-muted shrink-0">
                  {option.count}
                </span>
              )}
            </XStack>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenuRoot>
  );
}
